import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import './style.css';
export const Link = ({ children, ...restProps }) => {
    const [firstRender, setFirstRender] = React.useState(false);
    useEffect(() => {
        if (!firstRender) {
            setFirstRender(true);
        }
    }, []);
    return (_jsx("a", { className: 'link', ...restProps, children: children }));
};
